import { createSlice } from "@reduxjs/toolkit";
import {
  createTalentByPlantelThunk,
  getTalentByplantelByIdThunk,
  getTalentsByPlantelThunk,
  toggleTalentActiveThunk,
  updateTalentByPlantelThunk,
} from "./plantels.thunks";

const initialState = {
  list: [],
  loading: false,
  error: null,

  page: 1,
  pageSize: 10,
  count: 0,

  formModalOpen: false,
  formLoading: false,
  formMode: "create",
  formError: null,

  selectedTalent: null,
  selectedTalentLoading: false,
  selectedTalentError: null,
  viewTalentModalOpen: false,

  confirmToggleOpen: false,
  toggleTalentId: null,
  toggling: false,
};

const talentosSlice = createSlice({
  name: "talentosByPlantels",
  initialState,
  reducers: {
    setTalentsPage: (state, action) => {
      state.page = action.payload;
    },

    openTalentForm: (state, action) => {
      state.formModalOpen = true;
      state.formMode = action.payload?.mode || "create";
      if (action.payload?.talent !== undefined) {
        state.selectedTalent = action.payload.talent;
      }
      state.formError = null;
    },

    closeTalentForm: (state) => {
      state.formModalOpen = false;
      state.formError = null;
    },

    openTalentView: (state) => {
      state.viewTalentModalOpen = true;
    },

    closeTalentView: (state) => {
      state.viewTalentModalOpen = false;
    },

    openConfirmTalentToggle: (state, action) => {
      state.confirmToggleOpen = true;
      state.toggleTalentId = action.payload.id;
    },

    closeConfirmTalentToggle: (state) => {
      state.confirmToggleOpen = false;
      state.toggleTalentId = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // GET LIST
      .addCase(getTalentsByPlantelThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getTalentsByPlantelThunk.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        state.list = payload.results || payload || [];
        state.count = payload.count || state.list.length;
      })

      .addCase(getTalentsByPlantelThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE
      .addCase(createTalentByPlantelThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })

      .addCase(createTalentByPlantelThunk.fulfilled, (state, action) => {
        state.formLoading = false;
        state.list = [action.payload, ...state.list]; // ← nueva referencia
        state.formModalOpen = false;
      })

      .addCase(createTalentByPlantelThunk.rejected, (state, action) => {
        state.formLoading = false;
        state.formError = action.payload;
      })

      // GET BY ID
      .addCase(getTalentByplantelByIdThunk.pending, (state) => {
        state.selectedTalentLoading = true;
      })

      .addCase(getTalentByplantelByIdThunk.fulfilled, (state, action) => {
        state.selectedTalentLoading = false;
        state.selectedTalent = action.payload;
      })

      .addCase(getTalentByplantelByIdThunk.rejected, (state, action) => {
        state.selectedTalentLoading = false;
        state.selectedTalentError = action.payload;
      })

      // UPDATE
      .addCase(updateTalentByPlantelThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })

      .addCase(updateTalentByPlantelThunk.fulfilled, (state, action) => {
        state.formLoading = false;

        state.list = state.list.map((t) =>
          t.id === action.payload.id ? action.payload : t,
        );

        if (state.selectedTalent?.id === action.payload.id) {
          state.selectedTalent = action.payload;
        }

        state.formModalOpen = false;
      })

      .addCase(updateTalentByPlantelThunk.rejected, (state, action) => {
        state.formLoading = false;
        state.formError = action.payload;
      })

      // TOGGLE ACTIVE
      .addCase(toggleTalentActiveThunk.pending, (state) => {
        state.toggling = true;
      })

      .addCase(toggleTalentActiveThunk.fulfilled, (state, action) => {
        state.toggling = false;

        const id = state.toggleTalentId;

        state.list = state.list.map((t) =>
          t.id === id ? { ...t, is_active: action.payload.is_active } : t,
        );

        if (state.selectedTalent?.id === id) {
          state.selectedTalent = {
            ...state.selectedTalent,
            is_active: action.payload.is_active,
          };
        }

        state.confirmToggleOpen = false;
      })

      .addCase(toggleTalentActiveThunk.rejected, (state) => {
        state.toggling = false;
      });
  },
});

export const {
  setTalentsPage,
  openTalentForm,
  closeTalentForm,
  openTalentView,
  closeTalentView,
  openConfirmTalentToggle,
  closeConfirmTalentToggle,
} = talentosSlice.actions;

export default talentosSlice.reducer;
